export const modalStyles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: '20px'
  },
  modal: {
    backgroundColor: '#0f0817',
    borderRadius: '16px',
    border: '1px solid rgba(124, 58, 237, 0.3)',
    maxWidth: '800px',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  modalHeader: {
    padding: '24px',
    borderBottom: '1px solid rgba(124, 58, 237, 0.2)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  modalTitle: {
    fontSize: '24px',
    fontWeight: '600',
    marginBottom: '8px'
  },
  modalCategory: {
    fontSize: '14px',
    color: '#8b5cf6',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  closeButton: {
    background: 'none',
    border: 'none',
    color: '#9ca3af',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '6px',
    transition: 'color 0.3s'
  },
  modalContent: {
    flex: 1,
    overflow: 'auto',
    padding: '24px'
  },
  modalSection: {
    marginBottom: '32px'
  },
  modalSectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  featureList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '12px'
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 0'
  },
  techSpecsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '16px'
  },
  techSpecItem: {
    background: 'rgba(124, 58, 237, 0.05)',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid rgba(124, 58, 237, 0.2)'
  },
  techSpecLabel: {
    fontSize: '12px',
    color: '#8b5cf6',
    marginBottom: '4px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  techSpecValue: {
    fontSize: '14px',
    fontWeight: '500'
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    gap: '16px'
  },
  statItem: {
    textAlign: 'center',
    padding: '16px',
    background: 'rgba(124, 58, 237, 0.05)',
    borderRadius: '8px',
    border: '1px solid rgba(124, 58, 237, 0.2)'
  },
  statValue: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#8b5cf6',
    marginBottom: '4px'
  },
  statLabel: {
    fontSize: '12px',
    color: '#9ca3af'
  },
  modalFooter: {
    padding: '24px',
    borderTop: '1px solid rgba(124, 58, 237, 0.2)',
    display: 'flex',
    gap: '12px'
  },
  modalButton: {
    flex: 1,
    padding: '12px 24px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },
  primaryModalButton: {
    background: 'linear-gradient(135deg, #7c3aed, #8b5cf6)',
    border: 'none',
    color: '#ffffff'
  },
  secondaryModalButton: {
    background: 'transparent',
    border: '1px solid rgba(124, 58, 237, 0.3)',
    color: '#8b5cf6'
  }
};